"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dayStringToDate = exports.epochSecondsToDate = exports.dateToDayString = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
exports.dateToDayString = (dt) => dayjs_1.default(dt).format("YYYY-M-D");
exports.epochSecondsToDate = (n) => {
    const d = new Date(0);
    d.setSeconds(n);
    return d;
};
exports.dayStringToDate = (s) => dayjs_1.default(s).toDate();
//# sourceMappingURL=dateToDayString.js.map